module.exports = __webpack_public_path__ + "media/images/pc/specials/common/clean_ribbon_gold-e1c9a05b8ca2fdc9028985200e3ce30d.svg";